export const analyticsDashboard = {
  // Common analytics card translations
  noHistoricalDataAvailable: "No historical data available",
  details: "Details",
  viewDetails: "View details",
  practiceName: "Practice name",
  last30Days: "Last 30 days",
  monthToDate: "Month-to-date",
  past12Months: "Past 12 months",
  last12Months: "Last 12 months",
  errorLoadingData: "There was a problem loading the data",
};
